
  import { defineComponent } from 'vue';
  import { updateOnboardingFinished } from '@/services/api/resources/onboarding';
  import { user } from '@/ui/auth/auth';
  import PartyIcon from '@/ui/components/newOnboarding/PartyIcon.vue';

  export default defineComponent({
    components: {
      PartyIcon,
    },
    setup() {
      if (!user.value.organization.onboardingFinished) {
        updateOnboardingFinished(user.value.organization.id)();

        user.value.organization.onboardingFinished = true;
      }
    },
  });
